import { Link } from "react-router-dom";

function Topbar() {
  return (
    <div class="text-center px-5 mb-4">
      <div class="row">
        <div class="col-lg-2">
          <Link
            to={"/shop"}
            class="btn btn-secondary adminPanel-btn  pt-3 fs-5"
          >
            Dashboard
          </Link>
        </div>
        <div class="col-lg-2">
          <Link
            to={"/invoicelist"}
            class="btn btn-secondary adminPanel-btn pt-3 fs-5"
          >
            Invoices
          </Link>
        </div>
        <div class="col-lg-2">
          <Link to={"/bill"} class="btn btn-secondary adminPanel-btn pt-3 fs-5">
            Bill
          </Link>
        </div>
        <div class="col-lg-2">
          <Link
            to={"/quotation"}
            class="btn btn-secondary adminPanel-btn pt-3 fs-5"
          >
            Quotation
          </Link>
        </div>


        <div class="col-lg-2">
          <Link
            to={"/customization"}
            class="btn btn-secondary adminPanel-btn pt-3 fs-5"
          >
            Customization
          </Link>
        </div>
        <div class="col-lg-2">
          <Link
            to={"/mailbox"}
            class="btn btn-secondary adminPanel-btn pt-3 fs-5"
          >
            Mailbox
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
